export default __webpack_public_path__ + "static/3-97bc8bb22c6217d455ead1eb1770c1f3.jpg";